import { track } from "../../actions";
export const movingInformationScreenState = {
    entry: [track],
    on: {
        NEXT: "estimation",
    },
};
